import * as Yup from "yup";
import * as moment from "moment";

export const defaultPalletFormData = () => {
    return {
        palletType: '',
        qty: ''
    }
}

export function initialValues(modalData) {
    let reqPickupDate = moment(modalData?.pickupDate).format('MM/DD/YYYY');
    let todayDate = moment().format('MM/DD/YYYY')
    // let actualPickupDateValue = moment(reqPickupDate).isAfter(todayDate) ? reqPickupDate : todayDate;
    let actualPickupDateValue = todayDate
    return (
        {
            actualPickupDate: actualPickupDateValue,
            documents: [],
            comment: '',
            acknowledgeCheck: false,
            quantityDiffPercent: 100,
            palletTypeFormData: [
                { ...defaultPalletFormData() }
            ]
        }
    )
}

export const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
        acknowledgeCheck: Yup.boolean().oneOf([true], 'Acknowledge'),
        actualPickupDate: Yup.date()
            .typeError('Invalid date')
            .nullable()
            .required('Date is required')
            .max(moment().endOf('day').toDate(), 'Date cannot be in the future'),
        comment: Yup.string().max(200, 'Comment must be at most 200 characters'),
        documents: Yup.array().min(1, 'At least one document is required'),
        palletTypeFormData: Yup.array().of(
            Yup.object().shape({
                palletType: Yup.string().required('Pallet Type is required'),
                qty: Yup.number().required('Quantity is required').min(1, 'Quantity must be greater than 0')
            })
        ),
    };

    return Yup.object().shape(schemaAttributes).noUnknown().strict(false);
};